<finxone-web-frontend-toggle-switch
  [widgetConfigData]="widgetConfigData"
  [contentStyle]="contentStyle"
  [iconStyle]="iconStyle"
  [textContentStyle]="textContentStyle"
  (valueChangeEmit)="updateNotificationSettings($event)"
  [widgetSettingsPropertyName]="'notificationSettings'"
></finxone-web-frontend-toggle-switch>
